var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-point-log-item"
  }, [_vm.arrangedFieldsForGrid.length > 0 ? _c('div', {
    staticClass: "s-point-log-item-info"
  }, _vm._l(_vm.arrangedFieldsForGrid, function (field, j) {
    return _c('div', {
      key: j,
      staticClass: "s-point-log-item-field"
    }, [field.type === 'ntd' ? [_c('p', {
      staticClass: "s-text-primary"
    }, [_c('span', {
      staticClass: "s-text-sm"
    }, [_vm._v("NT$ ")]), _c('span', {
      staticClass: "s-font-bold"
    }, [_vm._v(_vm._s(_vm.$currency(_vm.getNtdAmount(field), "")))])])] : field.type === 'primary' ? [_c('p', {
      staticClass: "s-point-log-item-field--point"
    }, [_c('span', [_vm._v(_vm._s(_vm.getPrimaryAmount(field)))])])] : field.type === 'primary_amount' ? [_c('p', {
      staticClass: "s-point-log-item-field--point"
    }, [_c('span', [_vm._v(_vm._s(_vm.$currency(_vm.getPrimaryAmount(field), "")))])])] : _vm.shouldShowField(field) ? _c('span', {
      class: _vm.getFieldClass(field)
    }, [_vm._v(" " + _vm._s(_vm.getFieldDisplayText(field)) + " ")]) : _vm._e()], 2);
  }), 0) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }